import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of } from "rxjs";
import { UnitMeasureService } from "@/core/services/unit-measure.service";
import { UnitMeasureActions } from "./unit-measure.actions";
import { UnitMeasureApiModel } from "@/core/models/api/unit-measure-api-model.model";
@Injectable()
export class UnitMeasureEffects {
    actions$ = inject(Actions);
    unitMeasureService = inject(UnitMeasureService);

    constructor(){

    }

    _loadUnitMeasure = createEffect(() => {
        return this.actions$.pipe(
            ofType(UnitMeasureActions.loadUnitMeasures),
            exhaustMap(() => {
                return this.unitMeasureService.getAll().pipe(
                    map((response: any) => {
                        const unitMeasures = response as UnitMeasureApiModel[];
                        return UnitMeasureActions.loadUnitMeasureSuccess({ unitMeasures });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })

    // _addProjectType = createEffect(() => {
    //     return this.actions$.pipe(
    //         ofType(ProjectTypeActionTypes.AddProjectType),
    //         exhaustMap((action) => {
    //             return this.projectTypeService.add(action.projectType).pipe(
    //                 map((response: any) => {
    //                     const projectType = response as ProjectTypeApiModel;
    //                     return ProjectTypeActions.addProjectTypeSuccess({ projectType });
    //                 }),
    //                 catchError((error) => {
    //                     console.error(error);
    //                     return of();
    //                 })
    //             )
    //         })
    //     )
    // })

    // _updateProjectType = createEffect(() => {
    //     return this.actions$.pipe(
    //         ofType(ProjectTypeActionTypes.UpdateProjectType),
    //         exhaustMap((action) => {
    //             return this.projectTypeService.update(action.categoryType).pipe(
    //                 map((response: any) => {
    //                     const projectType = response as ProjectTypeApiModel;
    //                     return ProjectTypeActions.updateProjectType({ projectType });
    //                 }),
    //                 catchError((error) => {
    //                     console.error(error);
    //                     return of();
    //                 })
    //             )
    //         })
    //     )
    // })

    // _deleteProjectType = createEffect(() => {
    //     return this.actions$.pipe(
    //         ofType(ProjectTypeActionTypes.DeleteProjectType),
    //         exhaustMap((action) => {
    //             return this.projectTypeService.delete(action.projectTypeId).pipe(
    //                 map((response: any) => {
    //                     return ProjectTypeActions.deleteProjectType({ projectTypeId: action.projectTypeId });
    //                 }),
    //                 catchError((error) => {
    //                     console.error(error);
    //                     return of();
    //                 })
    //             )
    //         })
    //     )
    // })
}